/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ROUTES_PATH } from "./Routes.Constant";
import Login from "components/Login/Login";
import RegistrationPage from "pages/RegistrationPage";
import ForgotPasswordPage from "pages/ForgotPasswordPage";
import React from "react";
import MyProfilePage from "pages/MyProfilePage";
import SaveConfigurationPage from "pages/SaveConfigurationPage";
import ShareDesign from "../components/ShareDesign/ShareDesign";
import ShareDesignPage2 from "pages/ShareDesignPage2";
import LookupConfigPage from "pages/LookupConfigPage";
import PageNoteFound from "components/Common/PageNotFound/PageNoteFound";
import ResetPassword from "components/ResetPassword/ResetPassword";
import Homepage from "../components/Homepage/Homepage";
import MainLayout from "layouts/MainLayout/MainLayout";
import ProtectedAuth from "./ProtectedAuth";
import PublicAuth from "./PublicAuth";
import PrivateAuth from "./PrivateAuth";
import Logout from "./Logout";
import CaptureDesign from "pages/CaptureDesign";

export const AppRouter: React.FC = () => {
  const privateLayout = (
    <PrivateAuth>
      <MainLayout />
    </PrivateAuth>
  );

  const protectedLayout = (
    <ProtectedAuth>
      <MainLayout />
    </ProtectedAuth>
  );

  const publicLayout = (
    <PublicAuth>
      <MainLayout />
    </PublicAuth>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path={""} element={privateLayout}>
          <Route path={ROUTES_PATH.USER_PROFILE} element={<MyProfilePage />} />
          <Route path={ROUTES_PATH.SAVE_CONFIGURATION} element={<SaveConfigurationPage />} />
          <Route path={ROUTES_PATH.SHARE_DESIGN_1} element={<ShareDesign />} />
          <Route path={ROUTES_PATH.SHARE_DESIGN_2} element={<ShareDesignPage2 />} />
          <Route path={ROUTES_PATH.LOGOUT} element={<Logout />} />
          <Route path={ROUTES_PATH.CAPTURE_DESIGN} element={<CaptureDesign />} />
        </Route>

        <Route path={""} element={protectedLayout}>
          <Route path={ROUTES_PATH.LOGIN} element={<Login />} />
          <Route path={ROUTES_PATH.REGISTRATION} element={<RegistrationPage />} />
          <Route path={ROUTES_PATH.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
          <Route path={ROUTES_PATH.RESET_PASSWORD} element={<ResetPassword />} />
        </Route>

        <Route path={""} element={publicLayout}>
          <Route index path={ROUTES_PATH.HOMEPAGE} element={<Homepage />} />
          <Route path={ROUTES_PATH.LOOKUP_CONFIG} element={<LookupConfigPage />} />
          <Route path="*" element={<PageNoteFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
